var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlanetPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 293 390.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 25px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.56,348.69H13V62.5L209.57,12.5c20.12,0,36.43,16.31,36.43,36.44v263.31c0,20.13-16.31,36.44-36.44,36.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.56,54.69H0v336h256.56c20.13,0,36.44-16.31,36.44-36.44V91.13c0-20.13-16.31-36.44-36.44-36.44ZM148.47,273.5c-45.23,0-81.9-36.67-81.9-81.9s36.67-81.9,81.9-81.9,81.9,36.67,81.9,81.9-36.67,81.9-81.9,81.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 133.5,
    cy: 191.19,
    r: 55.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanetPass);
export default __webpack_public_path__ + "static/media/icon-planet-pass.0baeb2b4288794f6ecb48923c05787dd.svg";
export { ForwardRef as ReactComponent };